<div class="modal-bg"
     *ngIf="isOpen">

  <div class="modal-dropdown box"
       (click)="click($event)"
       [style.height.px]="modalHeight"
       [style.left.px]="x"
       [style.top.px]="y">

    <div class="header">
      <div [translate]="title"></div>

      <div *ngIf="includeShowAll"
           [matTooltip]="'MODAL.SHOW_UNLINKED_DEPARTMENTS' | translate"
           class="switch">
        <pop-switch [(isSwitched)]="showAllDepartments"
                    [disabled]="showAllDepartmentsDisabled"></pop-switch>
      </div>
    </div>

    <pop-department-picker [departmentFilter]="!showAllDepartments ? filterDepartments : undefined"
                           [(selectedDepartment)]="selectedDepartment"
                           styleClass="rem-fix"></pop-department-picker>


    <button class="pop-button"
            [disabled]="!selectedDepartment"
            [translate]="actionLabel"
            (click)="selectDepartment()">

    </button>

  </div>
</div>
